import React, { useContext } from 'react';
import { quoteStatus } from '../../../data/quoteStatus';
import { devis, avis, signature, calendrier } from '../../../utils/images';
import { ClientContext } from '../../Contexts/contexts';

function TopCardsUser() {
  const clientContext = useContext(ClientContext);

  function getActiveStatusQuote() {
    if (clientContext?.clientExpertRelation === undefined) {
      // Vérifie si dans les rejetés, il a donné son avis ou pas
      const unsignedCer =
        clientContext?.clientExpertRelations?.find(
          (clientExpertRel) => clientExpertRel?.clientSigned === 0
        ) !== undefined;

      // Vérifie si une relation a le statut "en cours d'investigation"
      const investigatedCer =
        clientContext?.clientExpertRelations?.find(
          (clientExpertRel) =>
            clientExpertRel?.status === quoteStatus.investigation
        ) !== undefined;

      if (unsignedCer !== undefined || investigatedCer !== undefined)
        return 'grey';

      return '';
    }

    if (clientContext?.clientExpertRelation?.status === 0) return '';

    return 'grey';
  }

  function getActiveStatusAppointment(checkStatus) {
    if (clientContext?.clientExpertRelation === undefined) return 'grey';

    if (checkStatus.includes(clientContext?.clientExpertRelation?.status))
      return '';

    return 'grey';
  }

  function getActiveStatusMission(checkedStatus) {
    if (clientContext?.clientExpertRelation === undefined) {
      const unsignedCer = clientContext?.clientExpertRelations?.find(
        (clientExpertRel) => clientExpertRel?.clientSigned === 0
      );

      if (unsignedCer !== undefined) return '';

      return 'grey';
    }

    if (checkedStatus.includes(clientContext?.clientExpertRelation?.status))
      return '';

    return 'grey';
  }

  function getActiveStatusReview(checkedStatus) {
    if (clientContext?.clientExpertRelation === undefined) {
      // Vérifie si une relation a le statut "en cours d'investigation"
      const investigatedCer =
        clientContext?.clientExpertRelations?.find(
          (clientExpertRel) =>
            clientExpertRel?.status === quoteStatus.investigation
        ) !== undefined;

      if (investigatedCer) return '';

      return 'grey';
    }

    if (checkedStatus.includes(clientContext?.clientExpertRelation?.status))
      return '';

    return 'grey';
  }

  function GetAvailableQuotes() {
    return (
      clientContext?.quotes?.filter((quote) => {
        for (const relation of clientContext?.clientExpertRelations || []) {
          if (relation?.quoteId === quote?.id) return false;
        }

        return true;
      }) || []
    );
  }

  function GetQuotesCard() {
    // Vérifie si dans les rejetés, il a donné son avis ou pas
    const unsignedCer =
      clientContext?.clientExpertRelations?.find(
        (clientExpertRel) => clientExpertRel?.clientSigned === 0
      ) !== undefined;

    // Vérifie si une relation a le statut "en cours d'investigation"
    const investigatedCer =
      clientContext?.clientExpertRelations?.find(
        (clientExpertRel) =>
          clientExpertRel?.status === quoteStatus.investigation
      ) !== undefined;

    const cerExist = clientContext?.clientExpertRelation !== undefined;

    if (unsignedCer || investigatedCer || cerExist) return 1;
    else return Math.min(GetAvailableQuotes()?.length || 0, 3);
  }

  function GetAppointmentCard() {
    if (clientContext?.isInStatus([1])) return 5;

    if (clientContext?.isInStatus([2, 3, 4, 5, 6])) return 1;

    const unsignedCer = clientContext?.clientExpertRelations?.find(
      (clientExpertRel) => clientExpertRel?.clientSigned === 0
    );

    const investigatedCer = clientContext?.clientExpertRelations?.find(
      (clientExpertRel) => clientExpertRel?.status === quoteStatus.investigation
    );

    if (unsignedCer !== undefined || investigatedCer !== undefined) return 1;

    return 0;
  }

  function GetMissionCard() {
    if (clientContext?.isInStatus([3, 4, 5, 6])) return 1;

    const unsignedCer = clientContext?.clientExpertRelations?.find(
      (clientExpertRel) => clientExpertRel?.clientSigned === 0
    );

    const investigatedCer = clientContext?.clientExpertRelations?.find(
      (clientExpertRel) => clientExpertRel?.status === quoteStatus.investigation
    );

    if (unsignedCer !== undefined || investigatedCer !== undefined) return 1;

    return 0;
  }

  return (
    <div className="top-cards-container">
      <div className={`top-cards ${getActiveStatusQuote()}`}>
        <div className="top-cards-infos">
          <span className="top-cards-title">Devis Proposés</span>
          <img src={devis} className="top-cards-icons" alt="devis"></img>
        </div>
        <div>
          <span className="top-cards-number">{GetQuotesCard()}</span>
          <span className="top-cards-details"></span>
        </div>
        <div className="top-cards-color-line yellow-line"></div>
      </div>
      <div className={`top-cards ${getActiveStatusAppointment([1, 2])}`}>
        <div className="top-cards-infos">
          <span className="top-cards-title">Rendez-vous</span>
          <img
            src={calendrier}
            className="top-cards-icons grey-filter"
            alt="calendrier"
          ></img>
        </div>
        <div>
          <span className="top-cards-number">{GetAppointmentCard()}</span>
          <span className="top-cards-details"></span>
        </div>
        <div className="top-cards-color-line purple-line"></div>
      </div>
      <div className={`top-cards ${getActiveStatusMission([3])}`}>
        <div className="top-cards-infos">
          <span className="top-cards-title">Lettre de mission</span>
          <img
            src={signature}
            className="top-cards-icons grey-filter"
            alt="signature"
          ></img>
        </div>
        <div>
          <span className="top-cards-number">{GetMissionCard()}</span>
          <span className="top-cards-details"></span>
        </div>
        <div className="top-cards-color-line blue-line"></div>
      </div>
      <div className={`top-cards ${getActiveStatusReview([4, 5, 6])}`}>
        <div className="top-cards-infos">
          <span className="top-cards-title">Donnez votre avis</span>
          <img
            src={avis}
            className="top-cards-icons grey-filter"
            alt="avis"
          ></img>
        </div>
        <div>
          <span className="top-cards-number"></span>
          <span className="top-cards-details"></span>
        </div>
        <div className="top-cards-color-line green-line"></div>
      </div>
    </div>
  );
}

export default TopCardsUser;
